export const CustomersService = {
    
    GetAllCustomersService(token, page, perPage, orderColumn, orderType, callback) {        
        fetch('https://api.colombialivinghotels.com/customer_all', {
        //fetch('/customer_all', {
            method: 'POST',
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                //'Authorization': 'Bearer '+userData.token
            },
            body: JSON.stringify({token:token, page:page, per_page:perPage, order_by:orderColumn, order_type:orderType})
        })
        .then(response => response.json())
        .catch(error => {
            console.error('Error:', error);
            alert("Error de conexión.");
        })
        .then(data => {
            console.log("GetAllUsersService Message:",data.Message);
            callback(parseInt(data.Status) ,data.Message, data.Users, data.TotalPages, data.Token);
        });
    },

    EditCustomerService(token, user, callback) {               
        fetch('https://api.colombialivinghotels.com/customer_edit', {
        //fetch('/customer_edit', {
            method: 'POST',
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                //'Authorization': 'Bearer '+userData.token
            },
            body: JSON.stringify({
                token:token,
                idusuario_cliente:user.idusuario.current,
                nombres:user.nombres.current.value,
                apellidos:user.apellidos.current.value,
                identificacion:user.identificacion.current.value,
                telefono:user.telefono.current.value,
                email:user.email.current.value,
            })
        })
        .then(response => response.json())
        .catch(error => {
            console.error('Error:', error);
            alert("Error de conexión.");
        })
        .then(data => {
            console.log("EditUsersService Message:",data.Message);            
            callback(parseInt(data.Status) ,data.Message, data.Token);
        });
    }
}